import './mask-field-boolean.scss'

import { defineComponent, PropType } from 'vue'

import { EntityField, EntityFieldStatus } from '@skinsoft/types';

import { reactiveVueMixin } from '@skinsoft/reactive-vue';

export const MaskFieldBoolean = defineComponent({
    mixins: [reactiveVueMixin],
    components: {

    },
    props: {
        entityField: {
            type: Object as PropType<EntityField>,
            required: true,
        },
        fieldValue: {
            type: Boolean,
        },
        editing: {
            type: Boolean,
        },
        getStatus: {
            type: Function as PropType<(entityField: EntityField) => EntityFieldStatus>,
            required: true,
        },
        dataCy: {
            type: String,
        },
    },
    template: require('./mask-field-boolean.html'),
    computed: {
        value: {
            get(): Boolean {
                console.log('TEST VALUE')
                console.log(this.fieldValue)
                console.log(typeof(this.fieldValue))
                return this.fieldValue
            },
            set(input: Boolean) {
                this.$emit("value-change", {
                    abstractEntity: this.entityField.abstractEntity,
                    fieldPath: this.entityField.path,
                    value: input,
                })
            },
        },
    },
    methods: {
        isReadonly(entityField: EntityField) {
            return entityField.isReadOnly || this.getStatus(entityField).disabled
        },
        infoMessage(entityField: EntityField): string | undefined {
            return this.getStatus(entityField).disabledMessage
        },
        errorMessage(entityField: EntityField): string | undefined {
            return this.getStatus(entityField).errorMessage
        },
        hasError(entityField: EntityField) {
            return this.getStatus(entityField).error
        },
    },
})
